var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.12,
    height: 12.12,
    viewBox: "0 0 12.12 12.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.037,10.041a3.79,3.79,0,0,0,.031-.606c0-.212-.031-.394-.031-.606l1.3-1a.278.278,0,0,0,.062-.394l-1.24-2.091a.3.3,0,0,0-.372-.121l-1.55.606a4.511,4.511,0,0,0-1.054-.606l-.217-1.606a.332.332,0,0,0-.31-.242H8.18a.332.332,0,0,0-.31.242L7.622,5.223a5.248,5.248,0,0,0-1.054.606l-1.55-.606a.29.29,0,0,0-.372.121L3.407,7.435a.366.366,0,0,0,.062.394l1.333,1c0,.212-.031.394-.031.606s.031.394.031.606l-1.3,1a.278.278,0,0,0-.062.394l1.24,2.091a.3.3,0,0,0,.372.121l1.55-.606a4.51,4.51,0,0,0,1.054.606L7.9,15.253a.3.3,0,0,0,.31.242H10.69a.332.332,0,0,0,.31-.242l.248-1.606a5.245,5.245,0,0,0,1.054-.606l1.55.606a.29.29,0,0,0,.372-.121l1.24-2.091a.365.365,0,0,0-.062-.394ZM9.419,11.556a2.122,2.122,0,1,1,2.169-2.121A2.132,2.132,0,0,1,9.419,11.556Z",
    transform: "translate(-3.375 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.7d69299b1fbc81ba1a5d5ef92c62af63.svg";
export { ForwardRef as ReactComponent };